import { each, find, findIndex, map, merge, slice, reject, sampleSize } from 'lodash';
import { defineStore } from 'pinia';
import ApiHelper from "plugins/api";
import { pinia } from 'plugins/store/index';
import { computed, ref } from 'vue';

type API_ITEM = {
  url?: string,
  loaded: boolean
}

interface Newstore extends Obj {
  page?: PageNews
  items: NewsItem[]
  apis: {
    page: API_ITEM
    list: API_ITEM
    details: API_ITEM
  },
  pagination: {
    page: number,
    perPage: number,
    max: number,
  }
}

const useStore = defineStore('News', () => {
  const state = ref<Newstore>({
    loaded: false,
    apis: {
      page: {
        url: undefined,
        loaded: false,
      },
      list: {
        url: 'news',
        loaded: false,
      },
      details: {
        url: undefined,
        loaded: false,
      }
    },
    page: undefined,
    items: [],
    pagination: {
      page: 1,
      perPage: 5,
      max: 1,
    }
  })

  const setLoaded = () => {
    state.value.loaded = true
  }

  //formatBuilder(formated.components)
  const setPage = (page: PageNews) => {
    console.debug('[news] setPage', page);
    state.value.page = page
    return page
  }
  const setItems = (items: NewsItem[]) => {
    // ensure if item before
    const previous = [...state.value.items]

    state.value.items = items
    
    if (previous.length > 0) {
      each(previous, mergeItem)
    }

    state.value.pagination.max = Math.ceil(items.length / state.value.pagination.perPage)
    return state.value.items
  }
  const mergeItem = (item: NewsItem) => {
    console.debug('[news] mergeIten', { item });
    if (!item) return
    if (state.value.items.length === 0) {
      setItems([item])
      return item
    }
    const findex = findIndex(state.value.items, ({ id }) => id === item.id)
    if(findex < 0) return
    state.value.items[findex] = merge({}, state.value.items[findex], item)
    return state.value.items[findex]
  }

  const loadPage = async (url:string) => {
    const api = state.value.apis.page

    const request = api.loaded
      ? Promise.resolve(state.value.page)
      : ApiHelper.get(url, {})
        .then(({ data }: any) => {
          console.debug('[] ', { ...data });
          return data as PageNews
        })
        .then(setPage)
        .then(data => {
          api.loaded = true
          return data
        })
    return request
  }
  const loadList = async () => {
    const api = state.value.apis.list

    const request = api.loaded
      ? Promise.resolve(state.value.items)
      : ApiHelper.get(api?.url || '', api)
        .then(({ data }: any) => {
          return map(data, ({ ...item }: any) => ({
            ...item,
          }))
        })
        .then(setItems)
        .then(data => {
          api.loaded = true
          return data
        })

    return request
      .then(data => {
        return data
      })
  }

  const loadDetails = async (url:string, id: number) => {
    const entry = getItemById(id)
    // if exist AND loaded+
    // if (entry?.loaded) return entry
    if (entry && ({}).hasOwnProperty.call(entry, 'loaded') && entry.loaded) {
      console.debug('[news] loadDetails - found loaded page', { entry });
      return Promise.resolve(entry)
    }

    const api = { ...state.value.apis.details }
    api.url = url

    return ApiHelper.get(api.url, api)
      .then(({ data }: any) => data as NewsItem)
      .then((data) => {
        console.debug('[news] loadDetail', data);

        console.log()
        return {
          ...data,
          loaded: true,
        }
      })
      .then(mergeItem)
  }

  const setPagination = (page: number) => {
    state.value.pagination.page = page;
  }
  const prevPagination = () => {
    if (state.value.pagination.page - 1 === 0) {
      state.value.pagination.page = 1
    } else {
      state.value.pagination.page = state.value.pagination.page - 1;
    }
  }
  const nextPagination = () => {
    if (state.value.pagination.page + 1 > state.value.pagination.max) {
      state.value.pagination.page = state.value.pagination.max
    } else {
      state.value.pagination.page = state.value.pagination.page + 1;
    }
  }

  function getItemById(id: number) {
    return find(state.value.items, (item) => item.id === id)
  }

  const cards = computed(() => state.value.items)
  const paginated = computed(() => {
    const items = state.value.items;
    const { page, perPage } = state.value.pagination;
    const pageStart = (page - 1) * perPage;
    const pageEnd = pageStart + perPage;
    const paginated = slice(items, pageStart, pageEnd);

    return paginated;
  })

  const getRelated = async (id?:number, max = 2) => {
    // if (!state.value.items?.length) {
    return loadList().then(() => {
      const items = state.value.items;
      const result = id ? sampleSize(reject(items, ['id', id]), max) : sampleSize(items, max);
      return result as NewsItem[];
    });
    // }

    // const items = state.value.items;
    // const result = id ? sampleSize(reject(items, ['id', id]), max) : sampleSize(items, max);
    // return result as NewsItem[];
  }

  return {
    state,
    setLoaded,
    loadPage,
    loadList,
    loadDetails,
    setPagination,
    prevPagination,
    nextPagination,
    getItemById,
    getRelated,
    // trigger loader (only for 1st route ?)
    loaded: computed(() => state.value.loaded),
    cards,
    paginated,
    pagination: computed(() => state.value.pagination)
  }
})
export const store = useStore(pinia);
export default store;
